// siteData.js - All replaceable content for the website
// Modify this file to customize all text, images, and links

export const siteConfig = {
  // Site Information
  siteName: "ICER - Institute of Continuing Education and Research",
  tagline: "Discovery with purpose. Innovation with impact.",
  description: "Cornellians create solutions that improve lives in New York, the nation, and the world.",
  
  // Logo and Brand Assets
  logo: {
    src: "/images/logo.png",
    alt: "ICER Logo",
    link: "#"
  },
  
  // Hero Section
  hero: {
    title: "ИРЭЭДҮЙДЭЭ ХӨРӨНГӨ ОРУУЛ",
    subtitle: "Дэлхийн стандартад нийцсэн мэдлэг чадвар, ёс зүйтэй мэргэжилтнүүдийг бэлтгэх зорилготой сургалт, судалгааны төв",
    backgroundImage: "https://i0.wp.com/edu-icer.mn/wp-content/uploads/2025/05/76826-cover.jpg?resize=1080%2C362&ssl=1",

    // ctaButton: {
    //   text: "Ирээдүйг судлах",
    //   link: "#"
    // }
  },
  
  // Navigation Menu
  navigation: [
    { label: "Нүүр", link: "/" },
    { label: "Бидний тухай", link: "/about" },
    { label: "Сургалт", link: "/courses" },
    { label: "Нийтлэл", link: "/articles" },
    { label: "Суралцагчийн булан", link: "https://lms.icer.mn" }
  ],
  
  // Quick Links
  quickLinks: [
    { label: "Cornell Chronicle", link: "http://news.cornell.edu" },
    { label: "Academic Calendar", link: "#" },
    { label: "Directory", link: "#" },
    { label: "Campus Maps", link: "#" }
  ],

  // Feature Cards
  featureCards: [
    {
      id: 1,
      icon: "assets/Icons_Red-01.svg",
      title: "АЛСЫН ХАРАА",
      description: "Монгол хүний хөдөлмөрийн бүтээмжийг 5 дахин нэмэгдүүлэх."
    },
    {
      id: 2,
      icon: "assets/Icons_Red-02.svg",
      title: "ЭРХЭМ ЗОРИЛГО",
      description: "Бүтээмжээ нэмэгдүүлэх хүсэлтэй хэн бүхэнд тасралтгүй боловсрол олгох."
    },
    {
      id: 3,
      icon: "assets/Icons_Red-03.svg",  
      title: "БАГШ НАР",
      description: "Манай багш нартай танилцах."
    }
  ],
  
  // Important Dates
  importantDates: [
    { date: "Dec 15", event: "Fall Semester Ends", link: "#" },
    { date: "Jan 20", event: "Spring Semester Begins", link: "#" },
    { date: "Feb 10", event: "Application Deadline", link: "#" }
  ],
  
  // Featured Stories/News
  featuredStories: [
    {
      id: 1,
      title: "Knitting machine makes solid 3D objects",
      excerpt: "Researchers develop innovative manufacturing technique using automated knitting technology.",
      image: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=400&h=300&fit=crop",
      link: "https://news.cornell.edu/stories/2025/11/knitting-machine-makes-solid-3d-objects",
      category: "Research"
    },
    {
      id: 2,
      title: "Neural implant smaller than salt grain wirelessly tracks brain",
      excerpt: "Breakthrough miniaturization enables new possibilities in neuroscience research.",
      image: "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=400&h=300&fit=crop",
      link: "https://news.cornell.edu/stories/2025/11/neural-implant-smaller-salt-grain-wirelessly-tracks-brain", 
      category: "Innovation"
    },
    {
      id: 3,
      title: "How federal funding cuts are impacting each NYS county",
      excerpt: "Analysis reveals varied effects across New York State communities.",
      image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=300&fit=crop",
      link: "https://news.cornell.edu/stories/2025/10/how-federal-funding-cuts-are-impacting-each-nys-county",
      category: "Policy"
    },
    {
      id: 4,
      title: "Finding could help avert melanoma relapses",
      excerpt: "Medical breakthrough offers new hope for cancer treatment.",
      image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=400&h=300&fit=crop",
      link: "https://news.cornell.edu/stories/2025/10/finding-could-help-avert-melanoma-relapses",
      category: "Health"
    },
    {
      id: 5,
      title: "New biodegradable graft could help cardiovascular patients",
      excerpt: "Sustainable medical innovation advances cardiac care options.",
      image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=400&h=300&fit=crop",
      link: "https://news.cornell.edu/stories/2025/01/new-biodegradable-graft-could-help-cardiovascular-patients",
      category: "Medicine"
    },
    {
      id: 6,
      title: "GLP-1 drugs may reduce surgery complications in patients with diabetes",
      excerpt: "Research shows promising benefits for surgical outcomes.",
      image: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=400&h=300&fit=crop",
      link: "https://news.cornell.edu/stories/2025/01/glp-1-drugs-may-reduce-surgery-complications-patients-diabetes",
      category: "Health"
    }
  ],
  
  // Statistics/Highlights
  statistics: [
    { value: "2018", label: "Үүсгэн байгуулагдсан" },
    { value: "400+", label: "CFA®  сургалтын төгсөгчид" },
    { value: "10+", label: "Faculty Members" },
    { value: "100+", label: "Academic Departments" }
  ],

  // Teachers
  teachers: [
    {
      id: 1,
      name: "С.Дашдорж",
      title: "CFA, MA",
      image: "/assets/Dashdorj.png",
      bio: ""
    },
    {
      id: 2,
      name: "Б.Ганзориг",
      title: "CFA, MBA",
      image: "/assets/Ganzorig.png",
      bio: ""
    },
    {
      id: 3,
      name: "Г.Хүслэн",
      title: "CFA",
      image: "assets/Khuslen.png",
      bio: ""
    },
    {
      id: 4,
      name: "Б.Мөнхжин",
      title: "CFA L2 CAND",
      image: "/assets/Munkhjin.png",
      bio: ""
    },
    {
      id: 5,
      name: "С.Өнөр",
      title: "MBA, MPA",
      image: "/assets/Unur.png",
      bio: ""
    },
    {
      id: 6,
      name: "Г.Ананд",
      title: "CFA L1, BEc",
      image: "/assets/Anand.png",
      bio: ""
    }
  ],

  // Collaborating Companies
  collaboratingCompanies: [
    {
      id: 1,
      name: "Golomt bank",
      logo: "/assets/Partner Logo_White-01.svg",
      website: "#"
    },
    {
      id: 2,
      name: "Premium Group",
      logo: "/assets/Partner Logo_White-02.svg",
      website: "#"
    },
    {
      id: 3,
      name: "TBCapital",
      logo: "/assets/Partner Logo_White-03.svg",
      website: "#"
    },
    {
      id: 4,
      name: "Invescore",
      logo: "/assets/Partner Logo_White-04.svg",
      website: "#"
    },
    {
      id: 5,
      name: "InvesCore Capital",
      logo: "/assets/Partner Logo_White-05.svg",
      website: "#"
    },
    
    {
      id: 6,
      name: "InvesCore Capital",
      logo: "/assets/Partner Logo_White-06.svg",
      website: "#"
    },
    
    {
      id: 7,
      name: "InvesCore Capital",
      logo: "/assets/Partner Logo_White-07.svg",
      website: "#"
    },
    {
      id: 8,
      name: "InvesCore Capital",
      logo: "/assets/Partner Logo_White-08.svg",
      website: "#"
    },
    {
      id: 9,
      name: "InvesCore Capital",
      logo: "/assets/Partner Logo_White-09.svg",
      website: "#"
    },
    {
      id: 10,
      name: "InvesCore Capital",
      logo: "/assets/Partner Logo_White-10.svg",
      website: "#"
    },
    {
      id: 11,
      name: "InvesCore Capital",
      logo: "/assets/Partner Logo_White-11.png",
      website: "#"
    },
    {
      id: 12,
      name: "InvesCore Capital",
      logo: "/assets/Partner Logo_White-12.png",
      website: "#"
    },
    {
      id: 13,
      name: "InvesCore Capital",
      logo: "/assets/Partner Logo_White-13.png",
      website: "#"
    },
    {
      id: 14,
      name: "InvesCore Capital",
      logo: "/assets/Partner Logo_White-14.png",
      website: "#"
    }

  ],
  
  // Footer Information
  footer: {
    copyright: "© 2025 ICER - All rights reserved.",
    address: "The Down Town Building- 14240 Монгол улс, Улаанбаатар хот, Сүхбаатар дүүрэг, 1-р хороо, Жамъяан гүний гудамж 18/1, 3 давхар, 301 тоот",
    phone: "(+976) 7676-0888",
    email: "info@icer.mn",
    socialMedia: [
      { platform: "Facebook", url: "https://www.facebook.com/icer.mn", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg> },
      // { platform: "Twitter", url: "https://twitter.com/icer.mn", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg> },
      { platform: "Instagram", url: "https://www.instagram.com/icer.mn", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg> },
      // { platform: "LinkedIn", url: "https://linkedin.com/company/icer.mn", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg> },
      { platform: "YouTube", url: "https://www.youtube.com/@iCERmn", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg> }
    ],
    links: [
      { label: "Privacy Policy", url: "#" },
      { label: "Terms of Use", url: "#" },
      { label: "Accessibility", url: "#" },
      { label: "Contact", url: "#" }
    ]
  }
};